
export const CHANGE_LOGIN = 'login/SET_LOGIN';
export const changeLogin = newLogin => ({
  type: CHANGE_LOGIN,
  payload: newLogin,
})

export const CHANGE_PASSWOND = 'login/CHANGE_PASSWOND';
export const changePasswond = newPassword => ({
  type: CHANGE_PASSWOND,
  payload: newPassword,
})

export const SET_SHOW_PASSWORD = 'login/SET_SHOW_PASSWORD';
export const setShowPassword = newSetShowPassword => ({
  type: SET_SHOW_PASSWORD,
  payload: newSetShowPassword,
})

export const LOGIN = 'login/LOGIN';
export const login = ({ accountName, password, passwordMD5, history }) => ({
  type: LOGIN,
  payload: { accountName, password, passwordMD5, history },
})

export const LOGOUT = 'login/LOGOUT';
export const logout = history => ({
  type: LOGOUT,
  payload: { history },
});

export const LOGIN_ERROR = 'login/LOGIN_ERROR';
export const loginError = params => ({
  type: LOGIN_ERROR,
  payload: params,
});

export const SHOW_ACCOUNT_NAME_ERROR = 'login/SHOW_ACCOUNT_NAME_ERROR';
export const showAccountNameError = errorStr => ({
  type: SHOW_ACCOUNT_NAME_ERROR,
  payload: errorStr,
});

export const SHOW_PASSWORD_ERROR = 'login/SHOW_PASSWORD_ERROR';
export const showPasswordError = errorStr => ({
  type: SHOW_PASSWORD_ERROR,
  payload: errorStr,
});
